import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type StudentImportService from 'teacher-ui-client/services/student-import'
import type RouterService from '@ember/routing/router-service'

export default class InvalidRoute extends Route {
  @service studentImport!: StudentImportService

  @service router!: RouterService

  beforeModel() {
    // Ensure the current file has failed validation before entering this route
    if (this.studentImport.importJob.valid !== false) void this.router.replaceWith('manage.students')
  }

  /**
   * Gravity responded with a 422 error code so import process has transitioned to this,
   * the 'invalid' route.
   */
  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const model = {
      errors: this.studentImport.importJob.validationErrors,
      subscriptionType,
    }

    return model
  }
}
